import Gradient from 'chartjs-plugin-gradient';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarController,
    BarElement,
    Title,
    Tooltip,
    Legend,
    Filler
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { prepareDatasetForBarChart } from '../../common/graphHelper';

// Note: changes to the plugin code is not reflected to the chart, because the plugin is loaded at chart construction time and editor changes only trigger an chart.update().
const image = new Image();
image.src = 'https://www.chartjs.org/img/chartjs-logo.svg';



ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarController,
    BarElement,
    Title,
    Tooltip,
    Filler,
    Legend, Gradient);

const _props = {
    labels: [],
    datasets: [],
    totalDatasets: 0,
    graphConfig:{},
    dataListTemplate:'',
    period:'',
    clickFilter:()=>{}
}


export function BarChart(props = _props) {

    const data = prepareDatasetForBarChart(props.labels,props.datasets,props.graphConfig,props.period);
    
    return <div className='row align-item-center mt-3 bar-chart'>
    <div className='col-md-12'>  
        <Bar options={{
            plugins: {
                legend: {
                    position: 'top',
                    labels: {
                        boxWidth: 22,
                        boxHeight: 4
                    },
                    onHover:(e)=>{
                        e.native.target.style.cursor = 'pointer';
                    },
                    onLeave:(e)=>{
                        e.native.target.style.cursor = 'default';
                    },
                },
                datalabels: {
                    borderColor: 'white',
                    borderRadius: 25,
                    borderWidth: 0,
                    color: 'white',
                    display: function (context) {
                        var dataset = context.dataset;
                        var count = dataset.data.length;
                        var value = dataset.data[context.dataIndex];
                        return value > count * 1.5;
                    },
                    font: {
                        weight: 'bold'
                    },
                    padding: 2,
                    formatter: (val) => {
                        return ''
                    }
                }
            },
            onClick: (e, activeEls) => {
                props.clickFilter(e, activeEls, data);
              },
            onHover:(e,activeEls)=>{
                e.native.target.style.cursor = activeEls[0] ? 'pointer':'';
              },

            scales: {
                x: {
                    grid: {
                        display: false
                    },
                    offset: true
                },
                y: {
                    grid: {
                        borderDash: [4],
                        display: true,
                        drawTicks:false,
                        lineWidth:[1.3]
                    }
                }
            },
            // Core options
            responsive: true,
            aspectRatio: 8 / 3.6,
            layout: {
                padding: 6
            }
            
        }

        }
       
         data={data} />
         </div>
      </div>


        
    
   
    
        
    
}
